<template lang="pug">
.home
  aside.aside
    .nav
      .system-name(@click="$router.push('/')") 坝陵河大桥
        span 无线传感器除湿监控系统
      .nav-bar
        .nav-buttom
          //- router-link(to="/balingheSensor/highFrequencyDevice?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553") 高频设备管理
          //- router-link(to="/balingheSensor/highFrequencyDataTable?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553") 高频实验数据表

          router-link(to="/balingheSensor/gasClamp") 全桥实时数据
          router-link(to="/balingheSensor/station") 主缆除湿机组
          router-link(to="/balingheSensor/stationAnchorSaddle") 锚鞍室除湿机组

          router-link(to="/balingheSensor/highFrequencyData?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553") 高频试验

          router-link(to="/balingheSensor/currentHumidityList?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553&sortByItemCount=1") 湿度数据清单
          router-link(to="/balingheSensor/errorRecord?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553") 报警记录
          //router-link(to="/balingheSensor/currentDataTable?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553") 实时数据表
          router-link(to="/balingheSensor/dataHistory?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553&scenarioId=TBD") 数据历史


  TimeBlock.time-block(bridgeName="GUANLING", size="radar-size")
  RadarBlock.radar-block2(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListDehumidifier"
    , :humidityPassLine="this.radarBlockHumidityLine", title="除湿机", ref="radar2", @initComplete="initNextRadar('radar0')")
  RadarBlock.radar-block0(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListDehumidifierEquivelant"
    , :humidityPassLine="this.radarBlockEquivelantHumidityLine", title="除湿机", ref="radar0", :initOnMount="this.radarBlockDelayInit", @initComplete="initNextRadar('radar1')"
    , :isEquivelant="this.radarBlockIsEquivelant")
  RadarBlock.radar-block1(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListClamp"
    , :humidityPassLine="this.radarBlockHumidityLine", title="气索夹", ref="radar1", :initOnMount="this.radarBlockDelayInit", @initComplete="initNextRadar('radar3')")
  RadarBlock.radar-block3(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListAnchor"
    , :humidityPassLine="this.radarBlockHumidityLine", title="锚室", ref="radar3", :initOnMount="this.radarBlockDelayInit", @initComplete="initNextRadar('radar4')")
  RadarBlock.radar-block4(:daysCount="this.radarBlockDaysCount", :polygonNameDeviceIdListDict="this.radarBlockNameDeviceIdListSaddle"
    , :humidityPassLine="this.radarBlockHumidityLine", title="鞍室", ref="radar4", :initOnMount="this.radarBlockDelayInit")
</template>

<script>
import TimeBlock from "@/components/TimeBlock";

export default {
  name: "Index",
  components: {
    TimeBlock,
  },
  data() {
    return {
      timer: null,
      bridgeId: "6edcfe29-44ab-44c6-88b0-0f67c021a553",
      historyScenarioList: [],
      radarBlockDaysCount: 3,
      radarBlockHumidityLine: 50,
      radarBlockEquivelantHumidityLine: 45,
      radarBlockIsEquivelant: true,
      radarBlockDelayInit: false,
      radarBlockNameDeviceIdListClamp: {
        "南侧索夹": [
          "54749eb9-f128-4fbd-b9a2-acdfd30ced63",
          "b342ca48-6987-4705-a1af-0f6650723d68",
          "aadddf1a-b97a-450c-bc47-afa47055edf0",
          "78975a63-bdf7-453a-ba34-0a308f1622b7",
          "f66eca72-fb8f-450c-a63a-14efa3f51280",
          "38588202-b92a-41e1-b684-308cb1328ea0",
          "1e097d77-33d2-41ac-befc-4b5c04961e6d",
          "f42408a5-cefe-43d4-9975-3d9f5bf21380",
          "3b2f9e44-1601-4726-aaf3-9aa974f626e6",
          "aa9ce7d7-817b-45c9-b379-30c47dfbddb9",
        ],
        "南侧进气夹": [
          "6e712a8c-03d6-423d-bd67-0a84a39a276b",
          "d1f39d4e-0285-4407-8927-136585e6879d",
          "81196f58-6694-439c-8f0c-dfe677adddd1",
          "99f6a12a-d29d-4590-9cff-8c8d8f5c9ba7",
          "37b2f100-1b31-4811-afc9-4969d2d5b61e",
          "37f0ba3f-ae2b-425c-a72f-1a09e1dd1b91",
          "6eed8cab-277d-42de-b116-93fe15d4a78b",
          "ece3385f-46c4-4551-aa0e-44f961e0b669",
        ],
        "南侧排气夹": [
          "27349ec3-b8e8-47b4-8e3e-400bfac50781",
          "48402187-783e-47ee-8ac8-86d5e9e1a1f3",
          "c4324a32-53fd-4c0c-94bb-cc008041932a",
          "566240e8-8142-4147-83ae-4a10588d4145",
          "5d4a90ba-8d40-44ac-aff8-4fac97c04c38",
          "20611bbf-e75b-4d78-8878-82428a7370ef",
          "5b1a0382-b980-4975-9488-b3f1baa0c133",
          "2ccb84c7-b380-4db9-ac88-c049b13d6873",
          "d2f77e54-cddc-416b-94c5-e69c44f04341",
          "3e742db9-a6b7-42b6-8bd1-1657cde1883f",
        ],
        "北侧索夹": [
          "fc61050c-7ba9-42ab-86c1-cf0b64f76abe",
          "71251b80-d698-4f67-b9a7-7064e0da2b9a",
          "8ce5f154-25e6-4fc0-be0b-513708330539",
          "d5fb81f4-98ea-43f1-a3f7-f42359eb8724",
          "30c16e46-e9ff-4ffd-ade1-3c0dd927cd06",
          "925eec53-2d81-42fd-a19b-c60a9b992c9f",
          "e2259977-f9ad-43a1-ab3d-3ee65d0c5ab9",
          "5d47eb2f-1337-4c01-a5c8-45bdca26e85d",
          "71af97a4-2e07-4140-94e8-3c0d02b509a3",
          "22229fd7-3afa-455f-9cea-3d5473f783dd",
        ],
        "北侧排气夹": [
          "e03cb916-f8f6-4215-a3db-5e5a507faad4",
          "9e10430f-5f6b-4bc4-800f-bc11c7bbbcd7",
          "364b9c7c-d6ac-4610-ba57-b034f00e4dd4",
          "c8e63109-1213-41d6-b7a2-9d22abff8aa3",
          "c8d51a4c-f322-4dee-864f-77f36028f4bd",
          "9bcf91ef-32fe-443c-80b1-0057a35faeb0",
          "3919cc87-e1c0-40e5-a7fa-fc37dcf210d0",
          "adcf5195-9ca3-4d1f-a2bd-1704bdd6f2f9",
          "658d055e-f7ae-488e-b660-94cc7983bc39",
          "0216aeaf-2ea7-4577-aad3-d76595ce6229",
        ],
        "北侧进气夹": [
          "7393f20c-805a-46ea-95d3-ffa3c648b700",
          "aeb69cac-38cf-466a-bb23-9549aa935bb4",
          "b0e614ba-e09a-4e96-b248-ad3443269e5b",
          "aedd09b2-00ec-49b9-b51d-0583b4638279",
          "96b1bd30-4579-4f8d-8f3b-a27f4c802778",
          "3e529bf1-444f-4a96-adfb-90972cba1410",
          "533da7cf-f207-4de5-a561-d7971c13f0db",
          "1f307bd5-79b8-40f6-8c68-511312a38529",
        ],
      },
      radarBlockNameDeviceIdListDehumidifier: {
        "东-镇宁(1#)": [
          "e423b5fa-cb76-4043-9db7-6a845f208d31",
          "9510b62a-b4dc-4023-9a89-9f77b5730269",
          "2467ded5-5e67-4424-bbf6-cc9660cc34e1",
          "ea984cd1-fa99-4f05-94b4-4cf88cb9613f",
          "5b0a9061-f4cc-4355-aa9f-aee6ddedf6f3",
          "935bbe69-0cdc-41eb-ba04-329c2e2348ec",
          "cec72d2d-7ac5-41b2-9bdf-6ffeef5cdcb3",
        ],
        "西-胜境关(2#)": [
          "cb91e21a-2fd2-4b63-95d2-6d695228bcfb",
          "abbd30c5-b2c7-4e01-92d6-58d0d1cecc58",
          "29e9e9c9-1f55-40c4-af0e-37863717872b",
          "e334f226-139a-4678-8139-8b6d360b626c",
          "47aba82e-8b67-4e74-90b0-09278ceceed5",
          "4cf6cde7-4f01-493a-81f9-2bea7cf9aada",
          "2efdc1a9-e37a-4365-bc7e-35975bae97bc",
        ],
        "跨中(3#)": [
          "671eae12-fea6-42aa-ac85-e3639c54cbf0",
          "c0e9a24d-875b-4a15-b279-547b038e56b6",
          "2ed83b6b-405c-48cd-a1da-fd0012036c23",
          "01c6c572-e11d-43a1-943f-bd3972af1e3b",
          "b3664e0b-7cb5-4b50-87f5-8c7a3e6cd2fa",
          "621b7c4c-2f96-4050-ae2a-c2f7b109d524",
          "f09876e5-bf98-462e-b190-82671f00a303",
        ],
      },
      radarBlockNameDeviceIdListDehumidifierEquivelant: {
        "东-镇宁(1#)": [
          "36e8d2fc-8af6-4299-8f3b-d890891f05be",
          "21bbb09c-a8da-49cb-8f2a-a491db7661fd",
          "9f4187a7-3340-4f7b-8f87-867136b509a7",
          "9e523ac8-66d1-4c62-8e11-b85bbd4c8452",
          "293367c0-5a52-4dc2-aab4-5c2517441b98",
          "7c2cbcda-89e0-401e-ad3f-8102352d1a69",
        ],
        "西-胜境关(2#)": [
          "c6396035-7733-4104-bc30-54835796e5ba",
          "5b933d5f-ecdf-48da-8948-31931f8d5f6f",
          "6d9078ab-be13-4675-abfa-038a555085f3",
          "c24016bd-7873-48c1-bd2d-671d9e9564a5",
          "1d35345a-e983-4edd-b809-ff04780bbb0b",
          "eb4ae8eb-0245-4c0e-b5b7-e4cdef68a0b7",
        ],
        "跨中(3#)": [
          "62c1d011-c626-4476-a740-719bb830f298",
          "90dc588e-786e-4ab3-9dc7-56d88c32507d",
          "265069ed-7864-455d-b4ca-5f97eedfe035",
          "d644734a-cc60-420d-b5a7-5cc9612c33bf",
          "f6afaf9c-ba18-4965-bd55-858ad2d74baf",
          "313abdd3-fe05-4b83-a490-ca3f0b7626fd",
        ],
      },
      radarBlockNameDeviceIdListSaddle: {
        "东-镇宁北": [
          "e9299725-657e-4b02-9eb0-6eda5f27b2f7",
          "7ce782c1-bb16-4da6-8b79-81ac1afc1363",
          "db1574c1-049d-4af0-bde4-215eb8f31865",
        ],
        "西-胜境关北": [
          "665dc765-34a3-4574-91b3-f97d94ea3210",
          "eec90c4d-ca9c-4e03-a3b8-c636beff4284",
          "10b97c34-a592-4a64-9c59-979458ca3fb1",
        ],
        "东-镇宁南": [
          "89b01dbb-e715-4412-ab94-61b94ffe0703",
          "25b0c55c-7c52-4c30-aae3-a2be072962d1",
          "dfdc9e93-96df-4f09-8397-caacb8c75440"
        ],
        "西-胜境关南": [
          "18c4ed78-2ab5-4782-be36-f451f57c8172",
          "b48f0d79-4475-40cb-8f3d-dd30388792e0",
          "26cac8e1-c64d-47b0-865a-06d1de4b3e7a"
        ],
      },
      radarBlockNameDeviceIdListAnchor: {
        "东-镇宁北": [
          "b6c58427-687b-4041-a01a-721fbcb07a07",
        ],
        "西-胜境关北": [
          "a2a8ff2a-03ba-421b-87b4-cefceaa40bb8",
        ],
        "东-镇宁南": [
          "5906e89a-bd87-401e-ab63-5b9de81f8d98",
        ],
        "西-胜境关南": [
          "d1969534-be6e-4679-98c6-59e716aa847a"
        ],
      }
    };
  },
  computed: {},
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => { });
    },
    initNextRadar(refName) {
      let radar = this.$refs[refName];
      if (radar) {
        setTimeout(() => {
          radar.initChart();
        }, 1000);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  min-height: 650px;
  position: relative;
  background: url("../../assets/image/balinghe/balinghe.jpg") center no-repeat;
  background-size: cover;

  .time-block {
    position: absolute;
    top: 100px;
    right: 150px;
  }

  .radar-block0 {
    position: absolute;
    top: 100px;
    right: 400px;
  }

  .radar-block1 {
    position: absolute;
    top: 280px;
    right: 650px;
  }

  .radar-block2 {
    position: absolute;
    top: 100px;
    right: 650px;
  }

  .radar-block3 {
    position: absolute;
    top: 280px;
    right: 400px;
  }

  .radar-block4 {
    position: absolute;
    top: 280px;
    right: 150px;
  }


  .aside {
    position: relative;
    width: 250px;
    height: 100%;
    color: #fff;
    min-width: 260px;
    text-align: center;
    box-shadow: 0 0 30px 0 #000;
    overflow: hidden;
    box-sizing: border-box;
    background: url("../../assets/image/balinghe/balinghe1.jpg") center no-repeat fixed;
    background-size: cover;

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #84a4c2;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background-color: transparent;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;

      a {
        display: block;
        width: 58%;
        height: 48px;
        margin: 0 auto 20px auto;
        border: none;
        line-height: 48px;
        border-radius: 5px;
        color: #4b4e50;
        background: #cadce9;
        cursor: pointer;
        text-decoration: none;

        &.same-line {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 18px;
        }

        p {
          margin: 0;
        }

        &:hover {
          color: #fff;
          background: #33a2f5;
        }
      }

      .system-name {
        height: 75px;
        font-weight: 700;
        font-size: 40px;
        margin: 75px 0;
        cursor: pointer;

        span {
          display: block;
          font-size: 18px;
        }
      }

      .nav-bar {
        height: calc(100% - 250px);
        overflow-y: auto;
      }
    }
  }
}
</style>